





























































import {
  Vue, Component, Watch, Prop,
} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Notification extends Vue {
  @Prop({ type: Boolean }) isShowing!: any;

  users = [];

  errors = [];

  show = true;

  dialog1 = false;

  // eslint-disable-next-line class-methods-use-this
  mounted() {
    this.$store.dispatch('bindNotifications', this.currentUser.uid);
  }

  open(data: any) {
    if (data === null) {
      console.log('from if');
      this.dialog1 = true;
    } else {
      this.$router.push(`/post/${data.id}`);
    }
  }

  get currentUser() {
    return this.$store.state.freshCurrentUser;
  }

  get Notify() {
    const notify = this.$store.state.notifications;
    return notify;
  }
}
